export enum AppsmithFrameAncestorsSetting {
  ALLOW_EMBEDDING_EVERYWHERE = "ALLOW_EMBEDDING_EVERYWHERE",
  LIMIT_EMBEDDING = "LIMIT_EMBEDDING",
  DISABLE_EMBEDDING_EVERYWHERE = "DISABLE_EMBEDDING_EVERYWHERE",
}
